import { styled, Theme, Button, Container, Typography } from '@material-ui/core';
import { StringBoolean } from 'src/types/types';

export const TOCChapterWrapper = styled(Container)<
  Theme,
  { bgcolor: string; isexpanded: StringBoolean; selected: StringBoolean }
>(({ bgcolor, isexpanded, selected }) => ({
  backgroundColor: bgcolor,
  padding: '16px 16px',
  borderRadius: isexpanded === 'true' ? '8px 8px 0 0' : 8,
  cursor: 'default',
  boxShadow: selected === 'true' || isexpanded === 'true' ? '0px 0px 16px 0px #00000073' : 'none',
  scale: selected === 'true' ? 1.03 : 1,
}));

export const SampleLessonButton = styled(Button)<Theme, { custombgcolor: string }>(
  ({ custombgcolor }) => ({
    color: '#FFFFFF',
    backgroundColor: `${custombgcolor}`,
    borderBottom: '2px solid #000000',
    boxShadow: 'inset 0 0 0 1000px rgba(0, 0, 0, 0.3)',
    padding: '8px 16px',
  })
);

export const TrajectoriesButton = styled(Button)<Theme>(() => ({
  color: '#FFFFFF',
  borderColor: '#FFFFFF',
  textTransform: 'none',
}));

export const TOCChapterTitle = styled(Typography)<Theme, { selected: StringBoolean }>(
  ({ selected }) => ({
    color: '#FFFFFF',
    fontSize: '32px',
    fontWeight: selected === 'true' ? 700 : 300,
    lineHeight: '120%',
  })
);
